import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import Reorder from 'react-reorder';
import classes from './ImagesManager.module.css';
import PlusIcon from 'assets/images/plus-icon.png';
import { changeArrayPosition } from 'shared/utility';

class ImagesManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: this.props.images,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.images !== prevProps.images) {
      this.setState({ images: this.props.images });
    }
  }

  updateImageOrder = (itemThatHasBeenMoved, itemsPreviousIndex, itemsNewIndex) => {
    const updatedImagesArray = changeArrayPosition([...this.state.images], itemsPreviousIndex, itemsNewIndex);
    this.setState({ images: updatedImagesArray });
    this.props.handlePostImageReorder(updatedImagesArray);
  };

  render = () => {
    let images = null;
    if (this.props.images.length > 0) {
      images = (
        <Reorder
          reorderId="my-list" // Unique ID that is used internally to track this list (required)
          reorderGroup="reorder-group" // A group ID that allows items to be dragged between lists of the same group (optional)
          component="ul" // Tag name or Component to be used for the wrapping element (optional), defaults to 'div'
          placeholderClassName={classes.listItemPlaceholder} // Class name to be applied to placeholder elements (optional), defaults to 'placeholder'
          draggedClassName={classes.Dragged} // Class name to be applied to dragged elements (optional), defaults to 'dragged'
          lock="horizontal" // Lock the dragging direction (optional): vertical, horizontal (do not use with groups)
          // holdTime={500} // Default hold time before dragging begins (mouse & touch) (optional), defaults to 0
          // touchHoldTime={500} // Hold time before dragging begins on touch devices (optional), defaults to holdTime
          // mouseHoldTime={200} // Hold time before dragging begins with mouse (optional), defaults to holdTime
          onReorder={this.updateImageOrder} // Callback when an item is dropped (you will need this to update your state)
          autoScroll={false} // Enable auto-scrolling when the pointer is close to the edge of the Reorder component (optional), defaults to true
          disabled={false} // Disable reordering (optional), defaults to false
          disableContextMenus // Disable context menus when holding on touch devices (optional), defaults to true
          placeholder={
            <div className={classes.listItemPlaceholder} /> // Custom placeholder element (optional), defaults to clone of dragged element
          }
        >
          {this.props.images.map((image, i) => (
            <div className={classes.ImageLineItem} key={i}>
              <div
                style={{ backgroundImage: `url(${image.Thumb2URL})`, width: '104px', height: '104px', maxHeight: '104px' }}
                className={classes.Image}
              />
              <FontAwesomeIcon
                icon="times"
                className={classes.DeleteImage}
                onClick={() => this.props.handleImageDeletion(i, this.props.images[i].Id)}
              />
            </div>
          ))}
        </Reorder>
      );
    }

    const containerClasses = [classes.Container];
    if (this.props.shortWindow === true) containerClasses.push(classes.ShortWindow);
    return (
      <div className={containerClasses.join(' ')}>
        <div className={classes.Header}>
          <span className={classes.Done} onClick={this.props.done}>
            Done
          </span>
          <h2 className={classes.Title}>Reorder</h2>
          <img src={PlusIcon} alt="Add More Images" className={classes.PlusIcon} onClick={this.props.plus} />
        </div>
        <p className={classes.prompt}>Drag and drop to reorder files</p>
        <div className={classes.ImagesContainer}>{images}</div>
      </div>
    );
  };
}

export default ImagesManager;
